import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getFormValues } from 'redux-form';
import Dialog from 'components/modals/Dialog';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import Button from 'components/buttons/Button';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import { setSequenceBuilderOpen } from 'redux/actions/campaignActions';
import {
  getSequences,
  createSequence,
  updateSequence,
  destroySequence,
} from 'redux/actions/sequenceActions';
import { getSchedules } from 'redux/actions/scheduleActions';
import { DEFAULT_SEQUENCE_NAME } from 'constants/sequence';
import SequenceSteps from './SequenceSteps';


class SequenceCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    campaign: PropTypes.shape({
      loaded: PropTypes.bool,
      id: PropTypes.number,
      account: PropTypes.number,
    }).isRequired,
    schedules: PropTypes.shape({
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    getSequences: PropTypes.func.isRequired,
    updateSequence: PropTypes.func.isRequired,
    destroySequence: PropTypes.func.isRequired,
    btnText: PropTypes.string,
    formValues: PropTypes.shape(PropTypes.any).isRequired,
    openSequenceBuilder: PropTypes.bool,
    setSequenceBuilderOpen: PropTypes.func,
    createSequence: PropTypes.func.isRequired,
    getSchedules: PropTypes.func.isRequired,
  };

  static defaultProps = {
    btnText: 'Add sequence',
    openSequenceBuilder: false,
    setSequenceBuilderOpen: () => {},
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.openSequenceBuilder,
      areYouSureModalIsOpen: false,
    };
    this.toggle = this.toggle.bind(this);
    this.launchSequence = this.launchSequence.bind(this);
  }

  async componentDidMount() {
    if (this.props.campaign.loaded) {
      await this.props.getSchedules({ account__id: this.props.campaign.account });
    }
    if (this.props.openSequenceBuilder && !this.props.sequence.id) {
      await this.props.createSequence({
        name: DEFAULT_SEQUENCE_NAME,
        campaign: this.props.match.params.id,
        schedule: this.getDefaultSchedule().id,
        status: false,
      });
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.campaign.loaded && !prevProps.campaign.loaded) {
      await this.props.getSchedules({ account__id: this.props.campaign.account });
    }
  }

  getDefaultSchedule = () => (
    this.props.schedules.results.find(s => s.is_primary) ||
      this.props.schedules.results.find(s => !s.account)
  )

  async launchSequence() {
    await this.props.updateSequence(this.props.sequence.id, {
      status: true,
    });
    this.closeModal();
  }

  toggle = () => {
    if (this.hasChanged()) {
      this.setState({ areYouSureModalIsOpen: true });
    } else {
      this.setState({
        isOpen: !this.state.isOpen,
      }, async () => {
        if (this.state.isOpen) {
          await this.props.createSequence({
            name: DEFAULT_SEQUENCE_NAME,
            campaign: this.props.match.params.id,
            schedule: this.getDefaultSchedule().id,
            status: false,
          });
        } else if (this.props.sequence.id) {
          await this.props.destroySequence(this.props.sequence.id);
        }
      });
      if (this.props.openSequenceBuilder) this.props.setSequenceBuilderOpen(false);
    }
  }

  closeModal = () => {
    this.setState({ isOpen: false }, () => {
      this.props.getSequences(this.props.campaign.id);
      this.props.setSequenceBuilderOpen(false);
    });
  }

  toggleAreYouSure(answer) {
    if (answer) {
      this.setState({
        areYouSureModalIsOpen: false,
        isOpen: false,
      }, async () => {
        if (this.props.sequence.id) {
          await this.props.destroySequence(this.props.sequence.id);
        }
      });
    } else {
      this.setState({ areYouSureModalIsOpen: false });
    }
  }

  hasChanged = () => this.props.formValues && (this.props.formValues.name || this.props.formValues.launch_date);

  render() {
    return (
      <div className={this.props.className}>
        <Button
          color="primary"
          variant="contained"
          onClick={this.toggle}
          size="large"
          startIcon={<PlusCircleOutlineIcon />}
          data-intercom-target="Add sequence button"
        >
          {this.props.btnText}
        </Button>
        <Dialog open={this.state.isOpen} onBackdropClick={this.toggle} fullScreen withPadding={false}>
          <SequenceSteps
            toggleModal={this.toggle}
            closeSequenceModal={this.closeModal}
            campaign={{ id: this.props.match.params.id }}
            launchSequence={this.launchSequence}
          />
        </Dialog>
        <ConfirmationModal
          open={this.state.areYouSureModalIsOpen}
          onBackdropClick={() => this.toggleAreYouSure(false)}
          title="Confirm"
          confirmLabel="Yes"
          cancelLabel="No"
          onConfirmClick={() => this.toggleAreYouSure(true)}
          onCancelClick={() => this.toggleAreYouSure(false)}
        >
          All changes will be lost. <br />Are you sure want to close?
        </ConfirmationModal>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    state => ({
      sequence: state.sequence,
      campaign: state.campaign,
      schedules: state.schedules,
      openSequenceBuilder: state.createCampaignState.openSequenceBuilder,
      formValues: getFormValues('sequenceCreateBasicForm')(state),
    }),
    {
      getSequences,
      createSequence,
      updateSequence,
      destroySequence,
      setSequenceBuilderOpen,
      getSchedules,
    },
  ),
  withNamespaces('common'),
)(SequenceCreate);
